export default __webpack_public_path__ + "static/media/line.ab295231.svg";